import React from 'react';

import * as S from './styles';
import { ItemDynamicPageInPhone } from 'types/ItemDynamicPageInPhone';
import Load from 'components/Load';
import { color } from 'styles/pallete';
import { DataFormProps } from 'components/FormDynamicPageSelected/Forms/InputsMediaYoutube';
import WaitingForDataDynamicPage from 'components/WaitingForDataDynamicPage';

interface MediaYoutubeProps {
	item: ItemDynamicPageInPhone;
}

export default function MediaYoutube({ item }: MediaYoutubeProps) {
	const { data } = item;
	const itemVideo: DataFormProps = data;

	function formatEmbedVideoUrl(videoUrl: string): string {
		const youtubeRegex =
			/(?:youtube\.com\/embed\/|youtu\.be\/|youtube\.com\/watch\?v=|youtube\.com\/shorts\/)([a-zA-Z0-9_-]+)/;
		const match = videoUrl.match(youtubeRegex);

		if (match && match[1]) {
			// Se já estiver no formato embed ou for um link válido do YouTube (incluindo shorts), retorna formatado
			return `https://www.youtube.com/embed/${match[1]}`;
		}

		return videoUrl; // Retorna o original caso não seja possível formatar
	}

	return Object.keys(item.data).length === 0 ? (
		<WaitingForDataDynamicPage />
	) : (
		<S.container
			$pBottom={itemVideo.paddingBottom || 0}
			$pTop={itemVideo.paddingTop}
		>
			{itemVideo.videoLink ? (
				<>
					<S.videoEmbed data-testid="video">
						<iframe
							title={`WebView ${itemVideo.videoLink || 0}`}
							src={formatEmbedVideoUrl(itemVideo.videoLink)}
							allow="fullscreen; picture-in-picture"
							allowFullScreen
							loading="lazy"
						></iframe>
					</S.videoEmbed>

					<S.load>
						<Load
							colorBackgound={color.system.success}
							showText
							text={'Carregando'}
						/>
					</S.load>
				</>
			) : (
				<S.noData>
					<p>Não há dado</p>
				</S.noData>
			)}
		</S.container>
	);
}
